module.exports = __webpack_public_path__ + "static/assets/831c96da7cd399a6db4213fc2d9bb3c8.png";